module.exports = __webpack_public_path__ + "img/henfu.fd4a3791.jpg";